import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ArrowRightIcon, LockIcon, SmartphoneIcon, CreditCardIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-10 md:py-14 px-6 bg-burgundy relative overflow-hidden" data-id="element-185">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-186">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-187">
          {/* Left side: Includes */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-cream" data-id="element-188">
            <p className="text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-189">
              Tu inversión en claridad
            </p>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 md:mb-8 font-serif" data-id="element-190">
              El Salto de
              <br data-id="element-191" />
              <span className="text-gold italic" data-id="element-192">Novia a Esposa</span>
            </h2>

            <ul className="space-y-3 mb-6 md:mb-8" data-id="element-193">
              {['eBook completo (7 capítulos)', '12 scripts de conversación exactos', 'Plan de retirada estratégica (14 días)', 'Plan de decisión (30 días)', 'BONUS: El Método Lucía', 'Acceso inmediato en cualquier dispositivo'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm md:text-base" data-id="element-194">
                  <span className="text-gold font-bold" data-id="element-195">✓</span>
                  <span data-id="element-196">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right side: Price Box */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream p-6 md:p-10 rounded-2xl shadow-2xl border-2 md:border-4 border-gold text-center relative" data-id="element-197">
            <div className="absolute top-0 right-0 bg-gold text-burgundy font-bold px-5 py-1.5 rounded-bl-2xl uppercase tracking-widest text-xs shadow-md" data-id="element-198">
              Oferta Especial
            </div>

            <p className="text-gray-600 mb-2 mt-3 text-sm md:text-base" data-id="element-199">
              Valor real:{' '}
              <span className="line-through decoration-burgundy/50" data-id="element-200">
                $97 USD
              </span>
            </p>

            <div className="text-5xl md:text-6xl font-bold text-burgundy mb-3 flex items-start justify-center font-serif" data-id="element-201">
              $9.95
            </div>

            <p className="text-gray-600 font-medium mb-6 text-sm md:text-base" data-id="element-202">
              Pago único · Acceso de por vida
            </p>

            <Button isCheckout className="w-full text-base px-6 py-5 shadow-xl hover:shadow-2xl flex items-center justify-center gap-3 mb-6" data-id="element-203">
              <span className="text-sm md:text-base" data-id="element-204">
                Quiero transformarme en una mujer de alto valor ahora
              </span>
              <ArrowRightIcon className="w-5 h-5" data-id="element-205" />
            </Button>

            <div className="flex flex-wrap justify-center gap-3 text-xs md:text-sm text-gray-600 font-medium" data-id="element-206">
              <div className="flex items-center gap-1.5" data-id="element-207">
                <LockIcon className="w-4 h-4 text-burgundy" data-id="element-208" />
                <span data-id="element-209">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-210">
                <SmartphoneIcon className="w-4 h-4 text-burgundy" data-id="element-211" />
                <span data-id="element-212">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-213">
                <CreditCardIcon className="w-4 h-4 text-burgundy" data-id="element-214" />
                <span data-id="element-215">Todas las tarjetas</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/10 rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-216"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold/10 rounded-full filter blur-3xl -translate-x-1/2 translate-y-1/2" data-id="element-217"></div>
    </section>;
}